import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import { householdEditRecordPersonalInformationUri } from 'Consts/advisorUris';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { GuidedHouseholdReviewFamilyLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

export const GuidedHouseholdReviewFamilyPageTemplate = ({ resource }) => {
  const { loadPageContentLink, setPageContentCollection } = usePageContentContext();
  const { householdId } = useSimpleHousehold();
  return (
    <MetaResourceRenderer
      metaOverrideSet={metaOverrideSet}
      layout={withGuidedHouseholdReviewLayout(GuidedHouseholdReviewFamilyLayout, { editLink: householdEditRecordPersonalInformationUri(householdId) })}
      onSubmit={setPageContentCollection}
      LayoutProps={{ navigateToLink: loadPageContentLink }}
      resource={resource}
    />
  );
};

GuidedHouseholdReviewFamilyPageTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
